export default {
  section_title: 'Sposób naliczania podatku',
  inherited_from_partner: 'Odziedziczone',
  inherited_from_region: 'Domyślne regionalne',
  reset: 'Przywróć odziedziczone',
  form: {
    tax_name: {
      label: 'Nazwa podatku',
      tooltip: 'Jak podatek jest nazywany na paragonach i fakturach, np. VAT lub GST.',
    },
    tax_behaviour: {
      label: 'Sposób naliczania podatku',
      tooltip: 'Czy ceny w menu zawierają już podatek, czy podatek jest doliczany przy płatności.',
      options: {
        inclusive: 'Wliczony w ceny menu',
        exclusive: 'Doliczany przy płatności',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Stawka podatku dla opłaty za dostawę',
      tooltip:
        'Stawka, według której opodatkowana jest Twoja opłata za dostawę, która może różnić się od stawki na jedzenie.',
    },
  },
  impact: {
    title: 'Zmienić sposób naliczania podatku dla Twoich restauracji?',
    affected_one: '{{count}} restauracja stosuje Twoje ustawienie domyślne i zostanie zmieniona.',
    affected_few: '{{count}} restauracje korzystają z Twojego ustawienia domyślnego i zostaną zmienione.',
    affected_many: '{{count}} restauracji korzysta z Twojego ustawienia domyślnego i zostanie zmienionych.',
    affected_other: '{{count}} restauracje stosują Twoje ustawienie domyślne i zostaną zmienione.',
    overriding_one: '{{count}} restauracja ma własne ustawienie i je zachowa.',
    overriding_few: '{{count}} restauracje mają własne ustawienie i je zachowają.',
    overriding_many: '{{count}} restauracji ma własne ustawienie i je zachowa.',
    overriding_other: '{{count}} restauracje mają własne ustawienia i je zachowają.',
    confirm: 'Zmień je',
  },
  buttons: {
    save: 'Zapisz',
    cancel: 'Anuluj',
  },
  toasts: {
    load_error: 'Nie udało się wczytać ustawień podatkowych',
    impact_error: 'Nie udało się sprawdzić, które restauracje to zmieni',
    impact_changed_one: 'Liczba restauracji, których to dotyczy, zmieniła się na {{count}}. Sprawdź i zapisz ponownie.',
    impact_changed_few: 'Liczba objętych restauracji zmieniła się na {{count}}. Sprawdź i zapisz ponownie.',
    impact_changed_many: 'Liczba objętych restauracji zmieniła się na {{count}}. Sprawdź i zapisz ponownie.',
    impact_changed_other:
      'Liczba restauracji, których to dotyczy, zmieniła się na {{count}}. Sprawdź i zapisz ponownie.',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
